import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls to top on in-app route changes only. Skips the initial mount so the
 * browser's native scroll restoration handles page reloads — that's what keeps
 * the user at the same place after F5 instead of being thrown to top/bottom
 * by an SPA-side `scrollTo(0)` racing against async content load.
 *
 * - Hash navigation (e.g., /about#team) is left to the browser
 * - Reduced-motion is respected by the `behavior: 'instant'` choice
 */
export const useScrollToTop = (): void => {
  const { pathname, hash } = useLocation();
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    if (hash) {
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);
};

export default useScrollToTop;
